"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=e(require("styled-components")).default.section`
    text-align: center;

    .PlannerQuestion-radio {
        display: flex;
        flex-wrap: nowrap;
        border: solid 1px ${({theme:e})=>e.colors.grey[300]};
        border-radius: 5px;
        width: 100%;
        max-width: ${({theme:e})=>e.widths.medium};
        margin: ${({theme:e})=>e.spacing.medium} auto; 
        position: relative;
        padding: 0 ${({theme:e})=>e.spacing.medium};

        &:hover {
            border: solid 2px ${({theme:e})=>e.colors.grey[300]};
        }
        
        &.active {
            background: rgb(0, 117, 201, 0.1);
            border: solid 2px ${({theme:e})=>e.colors.primary.default};
        }

        .PlannerQuestion-input {
            -webkit-appearance: none;
            appearance: none;
            position: absolute;
            width: 100%;
            height: 100%;

            &:hover {
                cursor: pointer;
            }
        }

        .PlannerQuestion-label {
            width: 100%;
            text-align: center;
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
